export const ElementScopeThemeChanger = (scope: string, theme: 'dark' | 'light' | 'reset') => {
	const elementScope = document.querySelector(scope);
	if (theme !== 'reset') {
		elementScope?.setAttribute('data-theme', theme);
	} else {
		elementScope?.removeAttribute('data-theme');
	}
};
